import getData from 'src/dataFetcher/getDataFetcher';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

export default async function getMailScans(parms,token) {
  const result = await getData(`${backendUrl}scan-status/details`,parms, token);
  return result;
}